/**
 * The home looks — ONE list of their keys, names and a one-line description.
 *
 * The designs themselves live in the gateway (services/api-gateway/src/lib/homeLookPresets.ts,
 * seeded into section_templates); this is the list every surface that NAMES a look reads instead
 * of keeping its own copy: the chat interview's Look step, and the tests that check the
 * launch page, the chat build's vibe words and the wizard's default all name real looks. The
 * gateway's own test fails when this list and the presets disagree, so a new look cannot be added
 * to one and forgotten in the other.
 */
export const HOME_LOOKS: ReadonlyArray<{ key: string; name: string; blurb: string }> = [
  { key: 'editorial', name: 'Editorial', blurb: 'Clean and simple, listings first' },
  { key: 'noir', name: 'Noir', blurb: 'Dark, luxe, high-contrast' },
  { key: 'heritage', name: 'Heritage', blurb: 'Classic serif, timeless' },
  { key: 'homestead', name: 'Homestead', blurb: 'Warm, earthy, welcoming' },
  { key: 'coastal', name: 'Coastal', blurb: 'Light, airy, breezy' },
  { key: 'vanguard', name: 'Vanguard', blurb: 'Modern, bold, clean lines' },
  { key: 'boulevard', name: 'Boulevard', blurb: 'Polished city style' },
  { key: 'prestige', name: 'Prestige', blurb: 'Refined luxury with your numbers' },
  { key: 'tidewater', name: 'Tidewater', blurb: 'Soft waterfront tones' },
  { key: 'portfolio', name: 'Portfolio', blurb: 'Sharp, modern, photo-led' },
  { key: 'signature', name: 'Signature', blurb: 'Editorial, refined' },
  { key: 'estate', name: 'Estate', blurb: 'Navy and gold, stately' },
  { key: 'gallery', name: 'Gallery', blurb: 'Big photos, few words' },
  { key: 'neighborhood', name: 'Neighborhood', blurb: 'Local expert, warm and friendly' },
  { key: 'bright', name: 'Bright', blurb: 'Cheerful, great for first-time buyers' },
  { key: 'team', name: 'Team', blurb: 'For brokerages and teams' },
];

export const HOME_LOOK_KEYS: ReadonlySet<string> = new Set(HOME_LOOKS.map((l) => l.key));
